<script>
export default {
  data: function () {
    return {
      lastSelectedExternalResourceRole: "external_resource",
    };
  },
  computed: {
    hasAnyExternalResourceRole() {
      return !!(
        this.userRoles?.["external_resource"] ||
        this.userRoles?.["region_external_resource"]
      );
    },
    selectedExternalResourceRole() {
      if (this.userRoles?.["external_resource"]) {
        this.lastSelectedExternalResourceRole = "external_resource";
      } else if (this.userRoles?.["region_external_resource"]) {
        this.lastSelectedExternalResourceRole = "region_external_resource";
      }
      return this.lastSelectedExternalResourceRole;
    },
  },
  methods: {
    selectDropdownRole: function (selectedRole) {
      this.userRoles.user = selectedRole === "user";
      this.userRoles.user_without_clinical_view =
        selectedRole === "user_without_clinical_view";
      this.userRoles.consultant = selectedRole === "consultant";
      this.userRoles.senior_consultant = selectedRole === "senior_consultant";
      this.userRoles.wound_user = selectedRole === "wound_user";
      this.userRoles.consultation_photographer =
        selectedRole === "consultation_photographer";
      this.userRoles.consultation_creator = [
        "consultant",
        "senior_consultant",
        "user",
        "user_without_clinical_view",
      ].includes(selectedRole);
    },
    updateHasAnyExternalResourceRole(value) {
      this.userRoles[this.selectedExternalResourceRole] = !!value;
    },
    updateSelectedExternalResourceRole(role) {
      this.lastSelectedExternalResourceRole = role;
      this.userRoles["external_resource"] = false;
      this.userRoles["region_external_resource"] = false;
      this.userRoles[role] = true;
    },
    dropdownRole: function (user) {
      const roles = user.roles ?? [];
      let userRole = roles.some((role) => role.name === "user");
      let consultantRole = roles.some((role) => role.name === "consultant");
      let woundUserRole = roles.some((role) => role.name === "wound_user");
      let seniorConsultantRole = roles.some(
        (role) => role.name === "senior_consultant",
      );
      let consultationPhotographerRole = roles.some(
        (role) => role.name === "consultation_photographer",
      );
      let uwcvRole = roles.some(
        (role) => role.name === "user_without_clinical_view",
      );

      if (consultantRole) {
        return "consultant";
      } else if (seniorConsultantRole) {
        return "senior_consultant";
      } else if (woundUserRole) {
        return "wound_user";
      } else if (consultationPhotographerRole) {
        if (this.$store.state.dermicusPlatform === "stockholm") {
          return "consultation_photographer";
        } else if (userRole) {
          return "user";
        }
        return;
      } else if (
        !consultantRole &&
        !seniorConsultantRole &&
        !consultationPhotographerRole &&
        !woundUserRole &&
        userRole
      ) {
        return "user";
      } else if (uwcvRole) {
        return "user_without_clinical_view";
      }
      return "";
    },
  },
};
</script>
